import React, { useState } from 'react';
import { Button, Input } from 'antd-mobile';
import { UpOutline, DownOutline, ForbidFill } from 'antd-mobile-icons';
import AttrString from '../../ProductMenu/AttrString';
import CurrencySymbol from '../../CurrencySymbol';
import intl from 'react-intl-universal';
import math, { formatNumber } from '../../../utils/math';
import ProductOriPrice from '../../ProductOriPrice';
import { isPackagePriceFree, shouldShowAsFree } from '../../../utils/price';

// 商品列表组件
const ProductList = ({ productArr, isOpenProductRemark, pdRemarkMap, setPdRemarkMap, from, events, hideFeeRate }) => {
    const [showAll, setShowAll] = useState(false);
    // 计算要显示的产品列表
    const displayProducts = showAll ? productArr : productArr.slice(0, 3);
    const hasMoreProducts = productArr.length > 3;
    return (
        <div className='bk-product-list'>
            <div>
                {displayProducts.map((item, index) => {
                    const { productName, amount, currency, productAmount, productId, taxAndServiceFee } = item;
                    return (
                        <div className='bk-product-item pos-rel' key={`${productId}-${index}`}>
                            <div className='jm-flex' style={{ gap: 10 }}>
                                <div className='jm-flex-item'>
                                    {productName}
                                    <AttrString product={item} />
                                </div>
                                <div
                                    className='jm-price'
                                    style={{
                                        borderRight: '1px solid #eae8e8',
                                        paddingRight: 10,
                                        color: 'var(--adm-color-primary)',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    {isPackagePriceFree(item) && !(productAmount > 0) ? (
                                        <><CurrencySymbol currency={currency} />{formatNumber(0)}</>
                                    ) : item.priceType === 4 || (shouldShowAsFree(item) && !(productAmount > 0)) ? (
                                        intl.get('free').d('免费')
                                    ) : (
                                        <><CurrencySymbol currency={currency} />{formatNumber(productAmount)}</>
                                    )}
                                    <ProductOriPrice item={item} />
                                </div>
                                <div className='text-gray'>
                                    <small>X</small>{amount || 1}
                                </div>
                            </div>
                            {
                                taxAndServiceFee && <>
                                    <div>
                                        {
                                            taxAndServiceFee.pd_service > 0 && (
                                                <div>
                                                    <small>
                                                        {intl.get('fees').d('服务费')}
                                                        {
                                                            !hideFeeRate && taxAndServiceFee.serviceFeeRate > 0 && taxAndServiceFee.serviceFeeType !== 4 ?
                                                                <>
                                                                    ({math.mul(taxAndServiceFee.serviceFeeRate, 100)}%)
                                                                </> : null
                                                        }
                                                    </small>&nbsp;&nbsp;
                                                    <small><CurrencySymbol currency={currency} />{formatNumber(taxAndServiceFee.pd_service)}</small>
                                                </div>
                                            )
                                        }
                                        {
                                            taxAndServiceFee.pd_tax > 0 && (
                                                <div>
                                                    <small>
                                                        {intl.get('taxes').d('税费')}
                                                        {
                                                            !hideFeeRate && taxAndServiceFee.taxRate > 0 && taxAndServiceFee.taxType !== 4 ?
                                                                <>
                                                                    ({math.mul(taxAndServiceFee.taxRate, 100)}%)
                                                                </> : null
                                                        }
                                                    </small>&nbsp;&nbsp;
                                                    <small><CurrencySymbol currency={currency} />{formatNumber(taxAndServiceFee.pd_tax)}</small>
                                                </div>
                                            )
                                        }
                                    </div>
                                </>
                            }
                            {isOpenProductRemark && (
                                <div className='bk-product-remark'>
                                    <Input
                                        type='text'
                                        placeholder={intl.get('special_note').d('Special Note:')}
                                        onChange={value => {
                                            const newPdRemarkMap = { ...pdRemarkMap };
                                            newPdRemarkMap[`${productId}-${index}`] = value;
                                            setPdRemarkMap(newPdRemarkMap);
                                        }}
                                    />
                                </div>
                            )}
                            {item.fromRec && (
                                <Button
                                    color='danger'
                                    size='small'
                                    fill='none'
                                    style={{ position: 'absolute', top: 5, right: -35, zIndex: 9 }}
                                    onClick={() => {
                                        events?.removeFromCart(item.productId, item.quantity, item);
                                    }}
                                >
                                    <ForbidFill fontSize={18} />
                                </Button>
                            )}
                        </div>
                    );
                })}
            </div>
            {/* 查看更多按钮 */}
            {hasMoreProducts && (
                <div className='bk-show-more text-center' style={{ marginTop: 10 }}>
                    <Button
                        size='mini'
                        fill='none'
                        color='primary'
                        onClick={() => setShowAll(!showAll)}
                    >
                        <div className='jm-flex'>
                            {showAll ? intl.get('collapse').d('收起') : intl.get('showMore').d('显示更多')}
                            {showAll ? <UpOutline fontSize={14} /> : <DownOutline fontSize={14} />}
                        </div>
                    </Button>
                </div>
            )}
        </div>
    );
};

export default ProductList; 